import axiosTokenInstance from 'services/api/backoffice';
import {
  DETAIL_FAILED_TRANSACTIONS_LIST_IPB,
  DETAIL_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
} from '_models/redux/types';

// Action function
export const failedTransactionsDetailListIpbAction = (iccid) => async (dispatch) => {
  try {
    const response = await axiosTokenInstance.get(
      `api/ipb/sims/${iccid}/activation-errors-details`,
      {
        responseType: 'text',
      },
    );

    const fixedText = response.data.replace(
      /"icc_number"\s*:\s*(\d+)/g,
      (_, number) => `"icc_number":"${number}"`,
    );

    const data = JSON.parse(fixedText);

    dispatch({
      type: DETAIL_FAILED_TRANSACTIONS_LIST_IPB,
      response: data || {},
      status: response.status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
      response: e || {},
    });
  }
};
